<div class="c-filters-toggle">
  @for (menu of filterMenus; track menu) {
    <button
      class="c-filters-toggle__btn"
      (click)="tabClick(menu.key)"
      [class.active]="selectedMenu == menu.key"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="collapseFilter"
    >
      {{ menu.label }}
      <i class="fa fa-caret-down tw-ml-2 tw-opacity-50"></i>
    </button>
  }

  <app-campaign-filters-portal [portalName]="portalName">
    <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" class="">
      @if (selectedMenuIndex >= 0) {
        @if (filterMenus[selectedMenuIndex].children) {
          <div class="c-filter__dropdown-section">
            <ul class="c-filter__dropdown-grid tw-mb-0 tw-grid tw-gap-2">
              @for (childMenu of filterMenus[selectedMenuIndex].children; track childMenu) {
                <li>
                  <app-campaign-filters-item-label
                    [menu]="childMenu"
                    [parentMenu]="filterMenus[selectedMenuIndex]"
                    [isActive]="isActive(childMenu)"
                    (onChange)="handleChange($event)"
                  />
                </li>
              }
            </ul>
          </div>
        } @else {
          <div class="lg:tw-grid lg:tw-grid-cols-4">
            @for (sectionMenu of filterMenus[selectedMenuIndex].childrenGroups; track sectionMenu) {
              <div class="c-filter__dropdown-section">
                <h5 class="tw-mb-2.5 tw-py-1 tw-text-base tw-font-medium">
                  {{ sectionMenu.label }}
                </h5>
                <ul
                  class="tw-mb-0 tw-grid tw-grid-cols-2 tw-gap-2 md:tw-grid-cols-3 lg:tw-flex lg:tw-flex-col"
                >
                  @for (childMenu of sectionMenu.children; track childMenu) {
                    <li>
                      <app-campaign-filters-item-label
                        [menu]="childMenu"
                        [parentMenu]="sectionMenu"
                        [isActive]="isActive(childMenu)"
                        (onChange)="handleChange($event)"
                      >
                      </app-campaign-filters-item-label>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        }
      }
    </div>
  </app-campaign-filters-portal>
</div>

<!-- Default case -->

<!-- With multiple section groups -->
